import { render, staticRenderFns } from "./CMapa.vue?vue&type=template&id=64ca5ac4&"
import script from "./CMapa.vue?vue&type=script&lang=js&"
export * from "./CMapa.vue?vue&type=script&lang=js&"
import style0 from "./CMapa.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports